import axios from "axios";
//import nProgress from "nprogress";
//import { useNavigate } from "react-router-dom";
//import { myroutes } from "../routes/webroute";
//import { useSelector } from "react-redux";

//const app_url = 'http://127.0.0.1:8000';

const app_url = 'dev-api.dgbook.africa';

export { app_url }

const http = axios.create({
    baseURL: 'dev-api.dgbook.africa',
    withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
})
 

/*
//creation d'un intercepteur de requete
http.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    nProgress.start()
    nProgress.configure({ easing: 'ease', speed: 500 });
    return config;
});

// les variable pour le panier
localStorage.setItem('nbrePanier', 0);
localStorage.setItem('contenuPanier', []);
// Add a response interceptor
http.interceptors.response.use(function (response) {
    nProgress.done()
    return response;
}, function (error) {
    //Si le serveur renvoie une erreur 401 deconnecter le user et redirection sur login page
    if (error.response.status === 401) {
      //En cas d'erreur 401 deconnecter le user
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      localStorage.removeItem("roles")
      //const navigate = useNavigate()
      //navigate(myroutes.login)
      window.location.href = `${process.env.PUBLIC_URL}/login`
      //return Promise.reject(error)
    }
    //return Promise.reject(error);
  });

const authCheck = async () => {
    //Check if user is authenticated
    // Vérifier si le token existe et n'est pas expiré
    const token = localStorage.getItem('token')
    if (token) {
        const jwtToken = JSON.parse(atob(token.split('.')[1])); // Décoder le token JWT
        //console.log(Date.now())
        //console.log(jwtToken)
        //console.log(jwtToken.exp * 1000)
        return Date.now() < (jwtToken.exp * 1000) ? true : false;
    } else return false
}
*/
//export { authCheck }
export default http;






/*const AxiosInterceptor = ({ children }) => {

    const navigate = useNavigate();

    useEffect(() => {

        const resInterceptor = response => {
            return response;
        }

        const errInterceptor = error => {

            if (error.response.status === 401) {
                navigate(myroutes.login);
            }

            return Promise.reject(error);
        }


        const interceptor = http.interceptors.response.use(resInterceptor, errInterceptor);

        return () => http.interceptors.response.eject(interceptor);

    }, [navigate])

    return children;
}
export {AxiosInterceptor}*/

